import validate from "/vercel/path0/node_modules/.pnpm/nuxt@3.11.2_@parcel+watcher@2.4.1_@types+node@20.14.10_bufferutil@4.1.0_eslint@8.57.0_ioredis_wi7zzs2my626d32xfwpds6ibz4/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/vercel/path0/node_modules/.pnpm/nuxt@3.11.2_@parcel+watcher@2.4.1_@types+node@20.14.10_bufferutil@4.1.0_eslint@8.57.0_ioredis_wi7zzs2my626d32xfwpds6ibz4/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {}